import { createBaseQuery as fetchBaseQuery } from '../baseQuery';
import { baseURL } from '../../../config';
import { createApi } from '@reduxjs/toolkit/query/react';

// Define the base URL for your API
const baseUrl = `${baseURL}/product-reviews`; // Updated base URL

export const reviewsApiService = createApi({
    reducerPath: 'reviewsApi', // Unique key for the reducer
    baseQuery: fetchBaseQuery({
        baseUrl,
        prepareHeaders: (headers) => {
            // Log headers if needed
           
            return headers;
        },
    }),
    endpoints: (builder) => ({
        getProductReviews: builder.query({
            query: (productId) => {
                const url = `/product/${productId}`;
                // Log the query URL and method
              
                return url; // Method is GET by default
            },
            keepUnusedDataFor: 0, // Optional: set the cache time
        }),
        addProductReview: builder.mutation({
            query: ({ productId, name, email, phone, content, rating }) => {
                const url = `/`; // Just use the base endpoint for adding reviews
                
                // Log the body being sent
                const requestBody = {
                    name,
                    email,
                    phone,
                    content,
                    rating,
                    productId,
                };
               
        
                return {
                    url,
                    method: 'POST', // Specify the method as POST
                    body: requestBody,
                };
            },
        }),
        
    }),
});

// Export the generated hooks for the queries and mutations
export const {
    useGetProductReviewsQuery,
    useAddProductReviewMutation, // Corrected the naming to be more consistent
} = reviewsApiService;
